const DRAFT_PREFIX = 'lms_code_draft_';

export function getDraftKey(contentId, studentPhone) {
  return `${DRAFT_PREFIX}${contentId}_${studentPhone || 'anonymous'}`;
}

export function saveLocalDraft(contentId, studentPhone, { language, code }) {
  if (!contentId) return;
  try {
    localStorage.setItem(
      getDraftKey(contentId, studentPhone),
      JSON.stringify({ language, code, savedAt: Date.now() }),
    );
  } catch {
    // Ignore quota errors
  }
}

export function loadLocalDraft(contentId, studentPhone) {
  if (!contentId) return null;
  try {
    const raw = localStorage.getItem(getDraftKey(contentId, studentPhone));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearLocalDraft(contentId, studentPhone) {
  if (!contentId) return;
  try {
    localStorage.removeItem(getDraftKey(contentId, studentPhone));
  } catch {
    // Ignore
  }
}

export function createAutoSaveHandler({ contentId, studentPhone, getState, intervalMs = 5000 }) {
  let timer = null;

  const start = () => {
    stop();
    timer = setInterval(() => {
      const { language, code } = getState();
      if (code?.trim()) {
        saveLocalDraft(contentId, studentPhone, { language, code });
      }
    }, intervalMs);
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  return { start, stop };
}

const PRACTICE_DRAFT_PREFIX = 'lms_practice_draft_';

export function getPracticeDraftKey(courseCode, studentPhone) {
  return `${PRACTICE_DRAFT_PREFIX}${String(courseCode || '').trim().toLowerCase()}_${studentPhone || 'anonymous'}`;
}

export function savePracticeDraft(courseCode, studentPhone, { language, code }) {
  if (!String(courseCode || '').trim() || !code?.trim()) return;
  try {
    localStorage.setItem(
      getPracticeDraftKey(courseCode, studentPhone),
      JSON.stringify({ language, code, savedAt: Date.now() }),
    );
  } catch {
    // Ignore quota errors
  }
}

export function loadPracticeDraft(courseCode, studentPhone) {
  if (!String(courseCode || '').trim()) return null;
  try {
    const raw = localStorage.getItem(getPracticeDraftKey(courseCode, studentPhone));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function createPracticeAutoSaveHandler({
  courseCode,
  studentPhone,
  getState,
  intervalMs = 5000,
}) {
  let timer = null;

  const start = () => {
    stop();
    timer = setInterval(() => {
      const { language, code } = getState();
      if (code?.trim()) {
        savePracticeDraft(courseCode, studentPhone, { language, code });
      }
    }, intervalMs);
  };

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  return { start, stop };
}
